import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: 'zh-CN', label: '简中' },
    { code: 'en', label: 'EN' },
    { code: 'zh-TW', label: '繁中' },
    { code: 'ja', label: '日本語' }
  ];

  return (
    <div className="lang-switcher">
      {languages.map((lang, idx) => (
        <React.Fragment key={lang.code}>
          {idx > 0 && <span className="lang-sep">/</span>}
          <button
            className={`lang-btn ${language === lang.code ? 'active' : ''}`}
            onClick={() => setLanguage(lang.code)}
          >
            {lang.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
